const e = "";
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/com-components/delivery-details/deliveryDetails.vue2.js
// module id = 860
// module chunks = 67